import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Group } from "types";
import { styled } from "@mui/material";
import Container from "@mui/material/Container";
import { DataGrid, GridColDef } from "@mui/x-data-grid";

const UsersTable = ({ handleModal, handleDialog, groups }: any) => {
  const dataGridMapper = (groups: Group[]): Group[] =>
    groups?.map((group: Group) => ({
      id: group?.groupID,
      ...group,
    })) ?? [];

  const dataGridColumns: GridColDef[] = [
    { field: "name", headerName: "Nombre", minWidth: 350 },
    { field: "description", headerName: "Descripción", width: 580 },
    {
      field: "actions",
      headerName: "Acciones",
      type: "actions",
      width: 120,
      renderCell: (params) => (
        <>
          <Link to={`/admin/group-edit/${params.id}`}>
            <IconButton aria-label='edit' size='small' onClick={handleModal}>
              <EditIcon fontSize='inherit' />
            </IconButton>
          </Link>
          <IconButton aria-label='delete' size='small' onClick={() => handleDialog(params.id)}>
            <DeleteIcon fontSize='inherit' />
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <ContainerStyled maxWidth='xl'>
      <div style={{ height: 615, width: "100%" }}>
        <DataGrid columns={dataGridColumns} rows={dataGridMapper(groups)} disableSelectionOnClick />
      </div>
    </ContainerStyled>
  );
};

export default UsersTable;

const ContainerStyled = styled(Container)`
  background-color: ${({ theme }) => theme.palette.background.default};
  height: 675px;
  padding: 1.7rem;
  margin: "auto";
`;
